//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MainObjects from "~/components/MainObjects.vue";
import MainArts from "~/components/MainArts.vue";
import MainInteresting from "~/components/MainInteresting.vue";
import CategoryTopItemsCarousel from "~/components/objects/CategoryTopItemsCarousel.vue";
import MainExperts from "~/components/MainExperts.vue";
import { trackHit } from "@/utils/helpers.js";
import { fetchCategoryTopItems } from "@/utils/searchObjectsAndArticles.js";
import { BUILD_STORAGE_PATH } from "@/constants/ui.js";

const CATEGORY_EXPERTS_DESKTOP_COLUMNS = 5
const CATEGORY_EXPERTS_TABLET_COLUMNS = 4
const CATEGORY_EXPERTS_MOBILE_COLUMNS = 2
const CATEGORY_EXPERTS_DESKTOP_INITIAL_ROWS = 1
const CATEGORY_EXPERTS_COMPACT_INITIAL_ROWS = 2
const CATEGORY_EXPERTS_TABLET_MEDIA = 1024
const CATEGORY_EXPERTS_MOBILE_MEDIA = 640
const CATEGORY_EXPERTS_INITIAL_LOAD_LIMIT = CATEGORY_EXPERTS_TABLET_COLUMNS * CATEGORY_EXPERTS_COMPACT_INITIAL_ROWS + 1

function findCategoryPath(tree, targetId) {
  for (const item of tree || []) {
    const node = item?.node
    if (!node) continue
    if (node.id === targetId) return [node]
    const nested = findCategoryPath(item?.items || [], targetId)
    if (nested.length) return [node, ...nested]
  }
  return []
}

export default {
  name: "ObjectsList",
  components: { MainObjects, MainArts, MainInteresting, CategoryTopItemsCarousel, MainExperts },
  layout: "public_new",
  async asyncData({ params, store, error }) {
    const order = params['slug'] === 'events' ? '-event_date.vfrom,-event_date.vto' : '-total_score'
    const currentCategory = await store.dispatch('categories/fetchObject', params['slug'])
      .catch(() => {
        return error({ statusCode: 404 })
      })
    const categories = await store.dispatch('categories/getNavTree')
    const breadcrumbs = findCategoryPath(categories, currentCategory?.id)
    const categoryTopItems = await fetchCategoryTopItems(store, currentCategory.top_items)
    const topExperts = await store.dispatch('users/fetchCategoryTopExperts', {
      category: currentCategory.id,
      limit: CATEGORY_EXPERTS_INITIAL_LOAD_LIMIT,
    }).catch(() => [])

    await Promise.allSettled([
      store.dispatch('art/fetchMaterialCategories'),
      store.dispatch('async_fetch_data/fetchDataInteresting', { category: currentCategory.id }),
      store.dispatch('art/getMainArts', {
        category: currentCategory.id,
        limit: 12,
        offset: 0,
        order: '-total_score',
        category_subtree: true,
      }),
      store.dispatch('objects/getMainObjects', {
        category: currentCategory.id,
        limit: 12,
        offset: 0,
        order,
        category_subtree: true,
      }),
    ])

    return {
      categories,
      breadcrumbs,
      currentCategory,
      objectsOrder: order,
      categoryTopItems,
      topExperts,
    }
  },
  data() {
    return {
      categories: [],
      breadcrumbs: [],
      currentCategory: {},
      objectsOrder: '-total_score',
      categoryTopItems: [],
      topExperts: [],
      categoryExpertsColumns: CATEGORY_EXPERTS_DESKTOP_COLUMNS,
      categoryExpertsRows: CATEGORY_EXPERTS_DESKTOP_INITIAL_ROWS,
      categoryExpertsViewportInited: false,
      categoryExpertsLoading: false,
    }
  },
  head() {
    return {
      title: this.headTitle
    }
  },
  computed: {
    categoryTitle() {
      return this.currentCategory.extra_label || this.currentCategory.label || ''
    },
    categoryHeaderStyle() {
      const imageUrl = this.currentCategory.image_id ? BUILD_STORAGE_PATH('categories', this.currentCategory.image_id) : require('@/assets/img/category-header-preview.png');
      return {
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.1) 100%), url("${imageUrl}")`,
        color: this.currentCategory.image_text_color || '#f9feff',
      }

    },
    headTitle() {
      return this.categoryTitle
        ? `Категория ${this.categoryTitle.toLowerCase()}`
        : 'Категория'
    },
    categoryExpertsHasMore() {
      return this.topExperts.length > this.categoryExpertsVisibleLimit
    },
    categoryExpertsVisibleLimit() {
      return this.categoryExpertsColumns * this.categoryExpertsRows
    }
  },
  mounted() {
    trackHit(this.$route.fullPath, this.headTitle, this.$route.meta.referer)
    this.updateCategoryExpertsViewport()
    window.addEventListener('resize', this.updateCategoryExpertsViewport, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCategoryExpertsViewport)
  },
  methods: {
    updateCategoryExpertsViewport() {
      const width = window.innerWidth

      if (width < CATEGORY_EXPERTS_MOBILE_MEDIA) {
        this.categoryExpertsColumns = CATEGORY_EXPERTS_MOBILE_COLUMNS
      } else if (width < CATEGORY_EXPERTS_TABLET_MEDIA) {
        this.categoryExpertsColumns = CATEGORY_EXPERTS_TABLET_COLUMNS
      } else {
        this.categoryExpertsColumns = CATEGORY_EXPERTS_DESKTOP_COLUMNS
      }

      if (!this.categoryExpertsViewportInited) {
        this.categoryExpertsRows = width >= CATEGORY_EXPERTS_TABLET_MEDIA
          ? CATEGORY_EXPERTS_DESKTOP_INITIAL_ROWS
          : CATEGORY_EXPERTS_COMPACT_INITIAL_ROWS
        this.categoryExpertsViewportInited = true
      }

      this.ensureLoadedCategoryExperts(this.categoryExpertsVisibleLimit + 1)
    },
    async ensureLoadedCategoryExperts(requiredLoadedCount) {
      if (this.categoryExpertsLoading || this.topExperts.length >= requiredLoadedCount) return

      this.categoryExpertsLoading = true
      try {
        const experts = await this.$store.dispatch('users/fetchCategoryTopExperts', {
          category: this.currentCategory.id,
          offset: this.topExperts.length,
          limit: requiredLoadedCount - this.topExperts.length,
        })

        this.topExperts = [...this.topExperts, ...experts]
      } finally {
        this.categoryExpertsLoading = false
      }
    },
    async showMoreCategoryExperts() {
      if (this.categoryExpertsLoading) return

      const nextRows = this.categoryExpertsRows + 1
      const nextVisibleLimit = this.categoryExpertsColumns * nextRows
      const requiredLoadedCount = nextVisibleLimit + 1

      await this.ensureLoadedCategoryExperts(requiredLoadedCount)
      this.categoryExpertsRows = nextRows
    },
  },
}
